import React from 'react'
import { ITagProformated } from '../../interfaces/auth'

export const useTags = (tags: string) => {
  const [value, setValue] = React.useState([])
  React.useEffect(() => {
    async function getTags(tags: string) {
      if (!tags) return []
      const tagsArray = tags?.split(',') || []
      setValue(tagsArray.map((item) => item.replace(/^\s+/, '')))
    }

    getTags(tags)
  }, [tags])

  return [value]
}

export const useSortTags = (tags: string[] | ITagProformated[]) => {
  const value = React.useMemo(() => {
    if (!tags) return []

    // validate if the tags are strings or objects
    if (typeof tags[0] === 'string') {
      // sort the tags alphabetically
      return tags.sort((a, b) => a.localeCompare(b))
    }

    // sort tags objects by priority label and then alphabetically
    return tags
      .sort((a, b) => {
        if (a.priority === b.priority) {
          return a.label.localeCompare(b.label)
        }
        return b.priority - a.priority
      })
      .map((item) => item.label)
  }, [tags])

  return [value]
}
